/* eslint-disable linebreak-style */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */

import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Button from '../elements/Button';

export default function Service({ data }) {
  return (
    <section className="container mx-auto flex flex-col items-center mt-20">
      <Fade direction="right" triggerOnce>
        <h1 className="text-5xl text-theme-blue text-center font-bold">Our Services</h1>
      </Fade>

      <Fade direction="left" triggerOnce>
        <p className="font-light text-lg text-center mb-12 max-w-3xl">
          We’re ready to scale your business with expert telecommunications, network cabling
          solutions, and safe, certified asbestos removal—helping you build with confidence and
          connect with reliability.
        </p>
      </Fade>

      {/* Fixed 3-column layout regardless of screen size */}
      <div className="grid grid-cols-3 gap-6 auto-rows-fr w-full px-4">
        {data.slice(0, 3).map((item, index) => (
          <Fade direction="up" triggerOnce delay={300 * index} key={item.id}>
            <Button type="link" href={`/service/${item.id}`}>
              <div className="group flex flex-col h-full rounded-2xl shadow-xl overflow-hidden transform transition duration-500 hover:scale-105">
                {/* Image */}
                <div className="h-48 w-full relative overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 flex items-center justify-center transition-all duration-300">
                    <svg
                      className="w-16 h-16 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  </div>
                </div>

                {/* Title */}
                <div className="flex-grow flex items-end justify-center px-4 py-5">
                <h2 className="text-theme-blue text-base sm:text-lg md:text-xl text-center font-semibold break-words leading-tight line-clamp-2">
  {item.title}
</h2>
</div>

              </div>
            </Button>
          </Fade>
        ))}
      </div>

      <Fade bottom triggerOnce>
        <Button
          href="/service"
          type="link"
          className="flex w-36 sm:w-40 lg:w-44 xl:w-36 h-12 sm:h-14 lg:h-16 xl:h-12 text-theme-purple px-5 border border-theme-purple items-center mt-14 rounded-full justify-center transition duration-300 hover:bg-theme-purple hover:text-white"
        >
          <p className="font-normal py-3 lg:text-lg xl:text-base">See More</p>
          <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <svg className="w-4 h-4 -ml-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Button>
      </Fade>
    </section>
  );
}
